<template>
  <div
    v-if="internalShow"
    :class="['alert-banner', `alert-banner--${color}`]"
  >
    <div
      class="alert-banner__container"
      :style="{
        maxWidth: containerWidth,
      }"
      :class="{
        'alert-banner__container--limited': !!containerWidth,
      }"
    >
      <div class="alert-banner__container-inner">
        <span>
          {{ text }}
        </span>
        <slot name="action">
          <sword-link v-if="link.to" :to="link.to" :text="link.text" />
        </slot>
      </div>
      <sword-icon-wuk name="close" @click.native="close" />
    </div>
  </div>
</template>

<script>
import SwordLink from '@ui-kit/components/links/SwordLink.vue';
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';

export default {
  name: 'SwordAlertBanner',
  components: { SwordLink, SwordIconWuk },
  model: {
    prop: 'show',
    event: 'update:show',
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'white',
      validator(value) {
        return ['white', 'dark', 'blue', 'neutral'].includes(value);
      },
    },
    link: {
      type: Object,
      default: () => ({ to: '', text: '' }),
    },
    containerWidth: {
      type: String,
    },
  },
  data() {
    return {
      internalShow: this.show,
    };
  },
  watch: {
    show(newVal) {
      this.internalShow = newVal;
    },
  },
  methods: {
    close() {
      this.internalShow = false;
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-banner {
  width: 100%;
  padding: 0.75rem $space-lg;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  color: $context-color-1;
  @extend %t3;
  @extend %-t_medium;

  @media screen and (max-width: $max-smartphone-size) {
    padding: 0.75rem $space-md;
  }

  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;

    &-inner {
      flex: 1;
      text-align: center;
    }

    &--limited {
      margin: 0 auto;

      .alert-banner__container-inner {
        text-align: left;
      }
    }
  }

  &--white {
    background-color: white;
    border-bottom-color: white;
  }

  &--dark {
    color: white;
    background-color: $color-grey-800;
    border-bottom-color: $color-grey-800;
  }

  &--blue {
    color: white;
    background-color: $color-primary-900;
    border-bottom-color: $color-primary-900;
  }

  &--neutral {
    background-color: $color-neutral-200;
    border-bottom-color: $color-grey-300;
  }

  .sword-icon.svg-icon {
    cursor: pointer;
  }
}
</style>
